import * as RadixPopover from '@radix-ui/react-popover'
import styled, { css } from 'styled-components'

import { WalletsAlertsTable } from '../wallet-alerts-table'

import { WalletAlertsDialogHeader } from './wallet-alerts-dialog-header'

import type { DialogControlProps } from '@root/shared/ui-kit'

type WalletAlertsDialogProps = {
  children: React.ReactElement
} & DialogControlProps

export const WalletAlertsDialog: React.FC<WalletAlertsDialogProps> = ({
  children,
  onOpenChange,
  open,
}) => {
  return (
    <RadixPopover.Root open={open} onOpenChange={onOpenChange}>
      <RadixPopover.Trigger asChild>{children}</RadixPopover.Trigger>
      <RadixPopover.Portal>
        <Content side="top" align="start" sideOffset={10}>
          <WalletAlertsDialogHeader
            onClose={() => {
              onOpenChange?.(false)
            }}
          />
          <WalletsAlertsTable
            css={css`
              height: 100%;
            `}
          />
        </Content>
      </RadixPopover.Portal>
    </RadixPopover.Root>
  )
}

const Content = styled(RadixPopover.Content)`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);

  width: 640px;
  height: 336px;

  border-radius: 12px;
  border: 1px solid var(--background-3);
  background: var(--background-1);
  box-shadow: 0 -10px 60px 0 var(--appearanceA-4);
`
